import "../scss/page.scss";

import "../scss/discovery.scss";

import "./scripts/slick/discovery";
import "./scripts/matchHeight/discovery";
import "./scripts/discovery/workshop";
import "./scripts/discovery/uncertainty";
import "./scripts/discovery/deliverables";
import "./scripts/discovery/form";